import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const TaskService = {

    taskByIdToView: async (taskId) => {
        const formData = new FormData();
        formData.append("taskId", taskId);
        return axios.post(`${API_DESPACHO}/task/taskByIdtoView/`, formData).then(({data}) => data).catch((err) => { throw err });
    },

    closeTask: async (taskId, cancelObservation) => {
        const formData = new FormData();
        formData.append("taskId", taskId);
        formData.append("cancelObservation", cancelObservation ?? "");

        return axios.post(`${API_DESPACHO}/task/setClose`, formData).then(({data}) => data).catch((err) => { throw err });
    },
    moveTaskToAttendance: async (taskId) => {
        const formData = new FormData();
        formData.append("taskId", taskId);

        return axios.post(`${API_DESPACHO}/task/move/attendance`, formData).then(({data}) => data).catch((err) => { throw err });
    },
};

export default TaskService;
